module.exports = __webpack_public_path__ + "static/media/doctorConsultBg.6be67a67.png";